'use client'
import React, { createContext, useContext, type ReactNode } from 'react'

export type HeaderType = 'solid' | 'transparent'

export interface HeaderContextProps {
  headerType: HeaderType
  setHeaderType: React.Dispatch<React.SetStateAction<HeaderType>>
}

export const HeaderContext = createContext<HeaderContextProps>({
  headerType: 'solid',
  setHeaderType: () => {},
})

export const HeaderProvider = ({ children }: { children: ReactNode; initialHeaderType?: HeaderType }) => {
  // const [headerType, setHeaderType] = useState<HeaderType>(initialHeaderType)

  return <HeaderContext value={{ headerType: 'solid', setHeaderType: () => {} }}>{children}</HeaderContext>
}

export const useHeaderContext = () => {
  const context = useContext(HeaderContext)
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider')
  }

  return context
}
